import React from "react";

export default function Spinner({ text }: { text?: string }): JSX.Element {
  return (
    <div className="Spinner">
      <p>{text || "Please wait..."}</p>
    </div>
  );
}
